export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Маркетинг',
        path: '/cases/marketing',
    },
];

export const listTitle = [
    {
        title: 'Как выбрать целевую аудиторию в&nbsp;узкой нише: кейс завода Bonum',
        description: [
            {
                name: 'Клиент',
                details: 'BONUM',
            },
            {
                name: 'Отрасль',
                details:
                    'Производство автотранспортных средств, прицепов, полуприцепов и&nbsp;сельхозтехники',
            },
            {
                name: 'Услуги',
                details: 'Контекстная и таргетированная реклама',
            },
        ],
    },
];
